import { http } from '@/core/api'

export type CommissionSummary = {
  pending: number
  confirmed: number
  paid: number
  total: number
  count: number
}

export type CommissionLine = {
  id: number
  trigger_type: string
  status: string
  amount: number
  currency: string
  occurred_at?: string | null
  application_id?: number | null
  job_order_id?: number | null
  worker_name?: string | null
  worker_phone?: string | null
  client_name?: string | null
  job_order_code?: string | null
  job_order_title?: string | null
}

export const commissionApi = {
  async mySummary(params?: { period?: string; from?: string; to?: string }) {
    const { data } = await http.get<{ data: CommissionSummary }>(
      '/recruitment/me/commission/summary',
      { params },
    )
    return data.data
  },

  async myLines(params?: { page?: number; per_page?: number; period?: string }) {
    const { data } = await http.get<{
      data: CommissionLine[]
      meta: { current_page: number; last_page: number; per_page: number; total: number }
    }>('/recruitment/me/commission/lines', { params })
    return data
  },
}
